module.exports = __webpack_public_path__ + "img/closedEye.b2c8b3f0.svg";